"use strict";

IREP.landing = (function (global) {
    var exampleTimeline = new TimelineMax({ paused: true });
    var $languages = $('#languages');
    var $aboutlink = $('#aboutlinks');

    var init = function () {

        //if (!Page_IsValid) {
        //    $(".errorPanelInner").slideDown();
        //}

        /* In IE8, the normal footer placement isn't working. This forces the position on the landing page */
        if ($("#IE8").length > 0) {
            $("#footer").css("position", "absolute");
            $("#footer").css("bottom", "0");
        }

        setTimeout(function () {
            if (IREP.options.isRTL) {
                //TweenLite.to('#landing-example', 1, { left: '-171px' });
            } else {
                //TweenLite.to('#landing-example', 1, { right: '-171px' });
            }
        }, 1000);

        if (IREP.options.isRTL) {
            exampleTimeline.add(TweenLite.to('#landing-example', 0.5, { left: '-15px' }));
        } else {
            exampleTimeline.add(TweenLite.to('#landing-example', 0.5, { right: '-15px' }));
        }

        $('#UserName').focus();

        var timeoutid;
        $('#landing-example').hover(function () {
            clearTimeout(timeoutid);
            //exampleTimeline.play();
        }, function () {
            timeoutid = setTimeout(function () {
                //exampleTimeline.reverse();
            }, 1000);
        });

        
        setupFooter();

        $(".rightwrapper").hover(function () {
            $(this).addClass("stop");
        }, function () {
            $(this).removeClass("stop");
        });
        
        $(function () {
            var myElem = document.getElementById('landingExampleWrapperLAR');
            if (myElem != null) {

                var player_name = videojs('#video_01');
                $(player_name).ready(function () {
                    player_name.on('ended', function () {
                        $("#videowrapper").fadeOut();
                        $(".rightwrapper").removeClass("stop");
                    });
                });

                if (!$(".rightwrapper").hasClass("stop"))
                    {
                $("#landingExampleWrapper").animate({
                    right: -500,
                }, 0)

                $("#landingExampleWrapperLAR").animate({
                    right: 0,
                }, 1200)
                }
                setTimeout(rotateone, 10000);
            }
        });

        function rotateone() {
            
            if (!$(".rightwrapper").hasClass("stop")) {
                $("#landingExampleWrapperLAR").animate({
                    right: -500,
                }, 1200)
                $("#landingExampleWrapper").animate({
                    right: 0,
                }, 1200)
            }
            setTimeout(rotatetwo, 10000);
        };

        function rotatetwo() {
            
            if (!$(".rightwrapper").hasClass("stop")) {
                $("#landingExampleWrapper").animate({
                    right: -500,
                }, 1200)
                $("#landingExampleWrapperLAR").animate({
                    right: 0,
                }, 1200)
            }
            setTimeout(rotateone, 10000);
        };
         

        $(".play").animate({
            opacity: .2,
        }, 800).animate({
            opacity: 1,
        }, 1000).animate({
            opacity: .2,
        }, 800).animate({
            opacity: .8,
        }, 600)

        
         
        function playFile() {
            var myPlayer = videojs('video_01');
            myPlayer.play();

            $(".rightwrapper").addClass("stop");
            var $window = $(window);
            var windowsize = $window.width();
            if (windowsize < 1400) {
                //if the window is greater than 440px wide then turn on jScrollPane..
                myPlayer.width(640).height(360);
                $("#video").addClass("smallVideo");
            }
            else {
                myPlayer.width(1280).height(720);

                $("#video").removeClass("smallVideo");

            }


        };

          

        function pauseFile() {
            var myPlayer = videojs('video_01');
            myPlayer.pause();

            $(".rightwrapper").removeClass("stop");
        };

        $("#landingExampleWrapperLAR .tryit").click(function () {
            $("#videowrapper").fadeIn();
            playFile();

        });

        $(document).mouseup(function (e) {
            if ($("#videowrapper").css('display') === 'block')
            {
                var container = $("#video");

            if (!container.is(e.target) // if the target of the click isn't the container...
                && container.has(e.target).length === 0) // ... nor a descendant of the container
            {

                $("#videowrapper").fadeOut();
                pauseFile();
            }
        }
        });
        

        $("#fyp").click(function () {
            $(".login").fadeOut();
            $(".fypdiv").fadeIn();
            $(".errorPanelInner").slideUp();
            TweenLite.to('.loginWrapper', 1, { height: $(".fypInnerWrapper").outerHeight(true) });
        });

        $("#btl").click(function () {
            $(".fypdiv").fadeOut();
            $(".login").fadeIn();
            $(".errorPanelInner").slideUp();
            TweenLite.to('.loginWrapper', 1, { height: $(".login").outerHeight(true) });
        });

        $(".errorPanel").click(function () {
            $(".errorPanelInner").slideUp();
        });

        $("#resendQST").click(function (event) {
            

            IREP.callApi("fieldsignup/resendEmail",
                "GET",
                { PaxUID: $("#resendQST").attr("uid") }
                ).done(function (data) {
                    console.log(data);
                    if (data.success) {
                        $("#resendQST").hide();
                        $("#QSTSent").show().css("cursor:default;");
                    }
                    else {
                        alert("an error has occured, sorry...");
                    }
                });

            event.stopImmediatePropagation();
            event.preventDefault();
        });
    };

    var checkUP = function () {
        $(".errorPanelInner > div").hide();

        if ($("#UserName").val() == "" || $("#Password").val() == "") {
            $("#UPRequired").show();
            $(".errorPanelInner").slideDown();
            return false;
        }

        return true;
    };

    var checkEmail = function () {
        $(".errorPanelInner > div").hide();
        
        if ($("#Email").val() == "") {
            $("#missingEmail").show();
            $(".errorPanelInner").slideDown();
            return false;
        }

        return true;
    };
    var setupFooter = function () {
        $('#links').find('.language').click(function () {
            var position = 0;

            if (IREP.options.isRTL) {
                position = $(window).width() - $(this).position().left - $languages.width() + ($(this).width() / 2);
                $languages.css('marginRight', position);
            } else {
                position = $(this).position().left - ($languages.width() / 2);
                position += $(this).width() / 2;
                $languages.css('marginLeft', position);
            }

            $languages.toggle();
            $aboutlink.hide();
            return false;
        });

        $('.about_link').click(function () {
            var position = 0;


            //position = $(this).position().left - ($aboutlink.width() / 2);
            //position += $(this).width() / 2;
            //$aboutlink.css('marginLeft', position);

            $('.dropdown-about').toggle();

            //$aboutlink.toggle();
            $languages.hide();

            return false;
        });
    };
    return {
        init: init,
        checkUP: checkUP,
        checkEmail: checkEmail,
        setupFooter: setupFooter
    };
}(this));
